import { Controller } from "stimulus"

export default class extends Controller {
  change(e) {
    $.ajax({
      url: `/patients/dashboard/appointments-for-professional?professional_id=${
        this.element.value
      }`
    })
  }
}
